import { useMutation } from '@apollo/client';
import CONFIRM_ASSIGNMENT_ACTION from '../queries/confirmAssignmentActionMutation';
import { useSelectedDateStore } from '../CalendarStore';
import { useNavigate } from 'react-router-dom';
import { showSuccessToast } from '@shared/services/toastService';
import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../components/shared/constants';

const previousLink = '/calendar';

const useConfirmAssignmentAction = (eventId, eventFormData) => {
  const navigate = useNavigate();
  const setSelectedDate = useSelectedDateStore.getState().setSelectedDate;

  const [confirmAssignmentAction, { error: confirmAssignmentActionError }] =
    useMutation(CONFIRM_ASSIGNMENT_ACTION);

  const handleConfirmAssignmentAction = async status => {
    const actionMessage =
      status === EVENT_APPRAISER_ASSIGNMENT_STATUS.ACCEPTED ? 'confirmed' : 'declined';

    await confirmAssignmentAction({
      variables: {
        assignmentData: { Status: status, EventId: eventId }
      }
    });

    showSuccessToast(`Assignment ${actionMessage} successfully.`);

    if (status === EVENT_APPRAISER_ASSIGNMENT_STATUS.REJECTED) {
      setSelectedDate(eventFormData.startDate);
      navigate(previousLink);
    }
  };

  return {
    handleConfirmAssignmentAction,
    error: confirmAssignmentActionError
  };
};

export default useConfirmAssignmentAction;
